"use client";

import * as React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        className="footer-area"
        sx={{
          textAlign: "center",
          bgcolor: "#fff",
          position: "fixed",
          bottom: 0,
          width: "100%",
          borderRadius: "7px 7px 0 0",
          padding: "20px 25px",
          left: "0",
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" px={4}>
          <Typography sx={{ pl: 3 }}>
            © 2025 <span className="text-primary">Steel Buddy. </span>All rights Reserved.
          </Typography>
          <Typography sx={{ pl: 1 }}>
            Developed by{' '}
            <a
              href="https://f9tech.com/"
              target="_blank"
              rel="noreferrer"
              className="text-primary"
              style={{ textDecoration: "none" }}
            >
              F9tech.
            </a>
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
